var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.2491 0.249523C8.91445 -0.0851275 8.36015 -0.0851275 8.02499 0.249523L5.00005 3.27447L1.9751 0.249523C1.64045 -0.0851275 1.08615 -0.0851275 0.750988 0.249523C0.416337 0.584173 0.416337 1.13848 0.750988 1.47363L3.77593 4.49858L0.750988 7.52353C0.416337 7.85818 0.416337 8.41248 0.750988 8.74764C0.924178 8.92083 1.14337 9.00156 1.36302 9.00156C1.58221 9.00156 1.80186 8.92083 1.97505 8.74764L5 5.72269L8.02495 8.74764C8.19814 8.92083 8.41733 9.00156 8.63698 9.00156C8.85617 9.00156 9.07582 8.92083 9.24901 8.74764C9.58366 8.41299 9.58366 7.85869 9.24901 7.52353L6.22406 4.49858L9.24901 1.47363C9.58366 1.13853 9.58376 0.584681 9.2491 0.249523Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.0c6a04a5b3410f02fecfeac343c0f56b.svg";
export { ForwardRef as ReactComponent };